import 'jquery';
import Masonry from 'masonry-layout';

const post_list = (function() {

  //
  //  Initialization / termination
  //
  const init = () => {
    // If no .post-list on the page, die
    if ( $('.post-list').length === 0 ) {
      return false;
    }

    // Apply masonry styles to .post-list--grid on page load.
    // It takes a few ticks for the post-list--grid class to
    // exist on the page for pages built with Elementor, so we wait 
    // until the class exists before applying Masonry.
    let waitForPostGridLoad = setInterval(function(count = 0) {
      if (count > 500) {
        console.log('post_list.js warning: Could not find a .post-list--grid after 5 seconds, quitting.');
        clearInterval(waitForPostGridLoad);
      }
      if (document.querySelector('.post-list--grid') !== null) {
        applyMasonry();
        clearInterval(waitForPostGridLoad);
      } else {
        count++;
      }
    }, 10);
  };

  const applyMasonry = () => {
    let grids = document.getElementsByClassName('post-list--grid');
    if ( grids ) {
      for ( let i=0; i<grids.length; i++ ) {
        new Masonry( grids[i], {
          columnWidth: '.post-list__post',
          itemSelector: '.post-list__post',
          gutter: 60,
        });
      }
    }
  };

  return {
    init: init,
  };
})();

$(document).ready(function() {
  post_list.init();
});


// WEBPACK FOOTER //
// ./scripts/partials/post-list.js